import React from 'react'
import { Grid, GridItem } from '../grid'
import DetailsItem from '../details-item'
import {
  formatShankWidth,
  formatShankDiamonds,
  formatSpecialFinish,
  formatBasketStyle,
  formatHandEngraving,
  formatShankShape,
  formatShankType,
  formatAdditionalDiamond,
  formatPrimaryMetalType,
  formatHalo,
  formatRingSize,
  formatMultiStone,
  formatCathedralShoulder,
  formatPrimaryDiamondShape,
  formatProngStyle,
  formatProngNumber
} from './field-formatters'

const RingDetails = props => (
  <Grid>
    <GridItem col='1/4'>
      <DetailsItem title='Primary Metal' value={formatPrimaryMetalType(props.data)} />
      <DetailsItem title='Shank Type' value={formatShankType(props.data)} />
      <DetailsItem title='Halo' value={formatHalo(props.data)} />
      <DetailsItem title='Basket Style' value={formatBasketStyle(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Ring Size' value={formatRingSize(props.data)} />
      <DetailsItem title='Shank Width' value={formatShankWidth(props.data)} />
      <DetailsItem title='Multi-Stone' value={formatMultiStone(props.data)} />
      <DetailsItem title='Cathedral Shoulders' value={formatCathedralShoulder(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Diamond Shape' value={formatPrimaryDiamondShape(props.data)} />
      <DetailsItem title='Shank Shape' value={formatShankShape(props.data)} />
      <DetailsItem title='Prong Style' value={formatProngStyle(props.data)} />
      <DetailsItem title='Hand Engraving' value={formatHandEngraving(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Additional Diamond(s)' value={formatAdditionalDiamond(props.data)} />
      <DetailsItem title='Shank Diamonds' value={formatShankDiamonds(props.data)} />
      <DetailsItem title='Prong Number' value={formatProngNumber(props.data)} />
      <DetailsItem title='Special Finish' value={formatSpecialFinish(props.data)} />
    </GridItem>
  </Grid>
)

export default RingDetails



// WEBPACK FOOTER //
// ./src/components/jewelry-details/ring-details.js